import * as yup from 'yup';

import { validateIdNumber } from '../../shared-constants';

export const basicDetailsSchema = yup.object({
  brand_name: yup.string().required('Brand name is required'),
  industry: yup.string().required('Industry is required'),
  custom_industry: yup.string().when('industry', {
    is: 'other',
    then: (schema) => schema.required('Please specify your industry'),
    otherwise: (schema) => schema.optional()
  }),
  nature_of_business: yup.string().required('Nature of business is required'),
  business_address: yup.string().required('Business address is required'),
  country: yup.string().nullable().required('Country is required'),
  bvn: yup
    .string()
    .required('BVN is required')
    .matches(/^\d{11}$/, 'BVN must be exactly 11 digits'),
  id_type: yup.string().required('ID type is required'),
  id_number: yup
    .string()
    .required('ID number is required')
    .test('id-format', 'Invalid ID number format', function (value) {
      const error = validateIdNumber(this.parent.id_type, value);
      return error ? this.createError({ message: error }) : true;
    }),
  is_pep: yup.string().required('Please select an option'),
  pep_full_name: yup.string().when('is_pep', {
    is: 'yes',
    then: (schema) => schema.required('Full name is required'),
    otherwise: (schema) => schema.optional()
  }),
  pep_relationship: yup.string().when('is_pep', {
    is: 'yes',
    then: (schema) => schema.required('Relationship is required'),
    otherwise: (schema) => schema.optional()
  }),
  pep_relationship_specify: yup.string().when('pep_relationship', {
    is: 'others',
    then: (schema) => schema.required('Please specify the relationship'),
    otherwise: (schema) => schema.optional()
  }),
  pep_position: yup.string().when('is_pep', {
    is: 'yes',
    then: (schema) => schema.required('Position is required'),
    otherwise: (schema) => schema.optional()
  }),
  pep_position_status: yup.string().when('is_pep', {
    is: 'yes',
    then: (schema) => schema.required('Position status is required'),
    otherwise: (schema) => schema.optional()
  }),
  pep_country: yup.string().when('is_pep', {
    is: 'yes',
    then: (schema) => schema.required('Country is required'),
    otherwise: (schema) => schema.optional()
  }),
  monthly_volume: yup.string().required('Monthly transaction volume is required'),
  source_of_funds: yup.string().required('Source of funds is required')
});

export const PEP_FIELDS = [
  'pep_full_name',
  'pep_relationship',
  'pep_relationship_specify',
  'pep_position',
  'pep_position_status',
  'pep_country'
];
